module.exports = __webpack_public_path__ + "img/skip-next.cea208ad.svg";